// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__lJqoX","content":"not-found_content__1SFvo"};